import React, { useState, useEffect } from "react";
import { eventsService } from "../services/api";
export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title_fr: "", title_en: "", description_fr: "", event_type: "official", location: "", event_date: "", event_time: "09:00" });
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => { loadEvents(); }, []);
  const loadEvents = () => {
    setLoading(true);
    eventsService.getEvents().then(r => { setEvents(r.data); setLoading(false); }).catch(() => setLoading(false));
  };
  const handleCreate = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await eventsService.createEvent(form);
      setShowForm(false);
      setForm({ title_fr: "", title_en: "", description_fr: "", event_type: "official", location: "", event_date: "", event_time: "09:00" });
      loadEvents();
    } catch { alert("Erreur lors de la création"); }
    finally { setSubmitting(false); }
  };
  const typeColors = { official: "#1A5C2A", environment: "#558B2F", health: "#C62828", economic: "#E65100", education: "#6A1B9A", other: "#8A8A9A" };
  const typeLabels = { official: "Officiel", environment: "Environnement", health: "Santé", economic: "Économique", education: "Éducation", other: "Autre" };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Événements</h1>
          <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{events.length} événement(s)</p>
        </div>
        <button onClick={() => setShowForm(!showForm)}
          style={{ background: "linear-gradient(135deg, #004D40, #00695C)", color: "white", border: "none", padding: "12px 24px", borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "Poppins" }}>
          + Nouvel événement
        </button>
      </div>
      {showForm && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
          <h3 style={{ margin: "0 0 20px", color: "#1A1A2E" }}>Créer un événement</h3>
          <form onSubmit={handleCreate}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Titre (FR) *</label>
                <input value={form.title_fr} onChange={e => setForm({...form, title_fr: e.target.value})} required
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Titre (EN)</label>
                <input value={form.title_en} onChange={e => setForm({...form, title_en: e.target.value})}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Type</label>
                <select value={form.event_type} onChange={e => setForm({...form, event_type: e.target.value})}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
                  {Object.entries(typeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Lieu *</label>
                <input value={form.location} onChange={e => setForm({...form, location: e.target.value})} required
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Date *</label>
                <input type="date" value={form.event_date} onChange={e => setForm({...form, event_date: e.target.value})} required
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Heure *</label>
                <input type="time" value={form.event_time} onChange={e => setForm({...form, event_time: e.target.value})} required
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Description (FR) *</label>
              <textarea value={form.description_fr} onChange={e => setForm({...form, description_fr: e.target.value})} required rows={4}
                style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <button type="submit" disabled={submitting} style={{ background: "#00695C", color: "white", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: submitting ? "not-allowed" : "pointer", fontFamily: "Poppins" }}>
                {submitting ? "Création..." : "Créer l'événement"}
              </button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "Poppins" }}>Annuler</button>
            </div>
          </form>
        </div>
      )}
      {loading ? <p style={{ textAlign: "center", color: "#8A8A9A" }}>Chargement...</p> : (
        <div style={{ display: "grid", gap: 12 }}>
          {events.map(e => (
            <div key={e.id} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderLeft: `4px solid ${typeColors[e.event_type] || "#8A8A9A"}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <span style={{ background: (typeColors[e.event_type] || "#8A8A9A") + "20", color: typeColors[e.event_type] || "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{typeLabels[e.event_type] || e.event_type}</span>
                  </div>
                  <h3 style={{ margin: "0 0 4px", fontSize: 15, fontWeight: 700, color: "#1A1A2E" }}>{e.title_fr}</h3>
                  <p style={{ margin: 0, fontSize: 13, color: "#8A8A9A" }}>📅 {e.event_date} à {e.event_time?.substring(0, 5)} • 📍 {e.location} • 👥 {e.attendees_count} inscrits</p>
                </div>
              </div>
            </div>
          ))}
          {events.length === 0 && <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Aucun événement. Créez le premier!</div>}
        </div>
      )}
    </div>
  );
}